import {
  LayoutDashboard, Briefcase, CalendarDays, Users, FolderClosed, BookOpen,
  Sparkles, PenLine, MessageSquareQuote, Scale, Workflow, Compass, Receipt, Settings, ClipboardList, ListChecks,
} from "lucide-react";

// Each item declares the permission gate; the sidebar filters by the active persona.
export const NAV_SECTIONS = [
  {
    label: "Workspace",
    items: [
      { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, perm: "matter.view" },
      { to: "/matters", label: "My Matters", icon: Briefcase, perm: "matter.view" },
      { to: "/calendar", label: "Calendar", icon: CalendarDays, perm: "matter.view" },
      { to: "/cause-list", label: "Cause List", icon: ClipboardList, perm: "matter.view" },
      { to: "/clients", label: "Clients", icon: Users, perm: "client.view" },
      { to: "/documents", label: "Documents", icon: FolderClosed, perm: "document.view" },
    ],
  },
  {
    label: "Intelligence",
    items: [
      { to: "/research", label: "Research", icon: BookOpen, perm: "research.view" },
      { to: "/ai-search", label: "AI Search", icon: Sparkles, perm: "research.view" },
      { to: "/drafting", label: "Drafting Studio", icon: PenLine, perm: "draft.view" },
      { to: "/review-desk", label: "Review Desk", icon: ListChecks, perm: "draft.view" },
      { to: "/cross-examination", label: "Cross-Examination", icon: MessageSquareQuote, perm: "draft.view" },
    ],
  },
  {
    label: "Operations",
    items: [
      { to: "/odr", label: "ODR", icon: Scale, perm: "odr.view", hideForRoles: ["Client"] },
      { to: "/automations", label: "Automations", icon: Workflow, perm: "automation.view" },
      { to: "/opportunities", label: "Opportunities", icon: Compass, perm: "opportunities.view" },
      { to: "/billing", label: "Billing & Payments", icon: Receipt, perm: "billing.view", hideForRoles: ["Client"] },
    ],
  },
  {
    label: "System",
    items: [
      { to: "/jobs", label: "Background Jobs", icon: ListChecks, perm: "matter.view", hideForRoles: ["Client"] },
      { to: "/settings", label: "Settings", icon: Settings, perm: "matter.view" },
    ],
  },
];

export const QUICK_ADD = [
  { key: "ai-intake", label: "AI Intake", perm: "matter.create" },
  { key: "matter", label: "New Matter", perm: "matter.create" },
  { key: "client", label: "New Client", perm: "client.edit" },
  { key: "task", label: "New Task", perm: "matter.view" },
  { key: "hearing", label: "New Hearing", perm: "matter.edit" },
  { key: "document", label: "Upload Document", perm: "document.upload" },
  { key: "draft", label: "Create Draft", perm: "draft.edit" },
  { key: "billing", label: "Add Billing Entry", perm: "billing.edit" },
];
